import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../types/enums/request-enums';

const GetStudioAddressBarcodes = (params?: {
    AddressBarcode?: string;
    AddressDefinition?: string;
    shotStatus?: number;
    IsActive?: boolean;
    PageNumber?: number;
    PageSize?: number;
}): Promise<any> => {
    const queryParams = new URLSearchParams();

    if (params?.AddressBarcode) queryParams.append('AddressBarcode', params.AddressBarcode);
    if (params?.AddressDefinition) queryParams.append('AddressDefinition', params.AddressDefinition);
    if (params?.shotStatus !== undefined) queryParams.append('shotStatus', params.shotStatus.toString());
    if (params?.IsActive !== undefined) queryParams.append('IsActive', params.IsActive.toString());
    if (params?.PageNumber) queryParams.append('PageNumber', params.PageNumber.toString());
    if (params?.PageSize) queryParams.append('PageSize', params.PageSize.toString());

    return request({
        url: `${ApiURL.Query.StudioQueryURLs.StudioAddressBarcodeQueryURL.GetStudioAddressBarcodes}?${queryParams.toString()}`,
        method: RequestType.GET,
    });
};

const GetStudioAddressBarcodesInformation = (params?: {
    AddressBarcode?: string;
    Barcode?: number;
    IsActive?: boolean;
    PageNumber?: number;
    PageSize?: number;
}): Promise<any> => {
    const queryParams = new URLSearchParams();

    if (params?.AddressBarcode) queryParams.append('AddressBarcode', params.AddressBarcode);
    if (params?.Barcode !== undefined) queryParams.append('Barcode', params.Barcode.toString());
    if (params?.IsActive !== undefined) queryParams.append('IsActive', params.IsActive.toString());
    if (params?.PageNumber) queryParams.append('PageNumber', params.PageNumber.toString());
    if (params?.PageSize) queryParams.append('PageSize', params.PageSize.toString());

    return request({
        url: `${ApiURL.Query.StudioQueryURLs.StudioAddressBarcodeQueryURL.GetStudioAddressBarcodesInformation}?${queryParams.toString()}`,
        method: RequestType.GET,
    });
};

export const StudioAddressBarcodeQuery = {
    GetStudioAddressBarcodes,
    GetStudioAddressBarcodesInformation,
};

export default StudioAddressBarcodeQuery;
